import { createSelector } from '@ngrx/store';
import { historyOrdersState } from '../root';

export const isLoadingAnyHistoryOrder = createSelector(
    historyOrdersState,
    (historyOrders) => historyOrders.isDownloading ? true : historyOrders.orders.some((obj) => obj.isDownloading === true)
);
